import {
  parseMessageModalFromPaymentException,
  PaymentException,
} from 'src/common/exceptions/paymentException';
import XLRLogger from 'src/common/helpers/logger';
import { voidActiveTransaction } from 'src/home-page/business-logic/void-transaction';
import { EmeraldErrorModal, EmeraldError } from '../../common/api/emerald-error';
import { AbortedError, ProhibitActionError } from '../../common/api/extended-emerald-error';
import { showEmeraldDialog } from '../../common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { addDefaultButtons } from '../../common/components/interactive-dialogue/components/interactive-dialogue-buttons/interactive-dialogue-buttons';
import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import {
  InvalidTareValue,
  SessionExpired,
  TenderNotAllowedForChange,
  tillClosingIdmPermissionError,
  ItemNotFound,
} from '../../common/helpers/error-code';
import { formatInvalidSessionError } from '../../common/helpers/invalid-session-helper';
import { IMessageModal } from '../../common/interfaces/dtos/IMessageModal';

export const popupMessage = (data: any, resolve?: () => void): void => {
  let messageItem: IMessageModal = {};

  // popup customized Emerald error modal
  if (data instanceof EmeraldErrorModal) {
    messageItem = data.errorModal;
  }
  // popup Payment Exception
  else if (data instanceof PaymentException) {
    messageItem = parseMessageModalFromPaymentException(data);
  }

  // popup BFF message
  else if (data instanceof EmeraldError) {
    if (data instanceof AbortedError) {
      return;
    }
    if (data.code === SessionExpired) {
      messageItem = formatInvalidSessionError(data.message);
    } else if (data instanceof ProhibitActionError) {
      if (!data.showInfo) {
        return;
      }
      messageItem = {
        message: data.code,
        type: EmeraldDialogTypes.Prohibit,
        subMessage: data.message,
      };
      if (data.voidTransactionOnDecline) {
        messageItem.onAccept = voidActiveTransaction;
      }
    } else if (data.code === InvalidTareValue || data.code === TenderNotAllowedForChange) {
      messageItem.message =
        data.code === InvalidTareValue
          ? 'InvalidTareValueHeading'
          : 'TenderNotAllowedForChangeHeading';
      messageItem.subMessage = data.message;
      messageItem.type = EmeraldDialogTypes.Warning;
    } else if (data.code === tillClosingIdmPermissionError) {
      messageItem.message = 'Till_Closing_Error';
      messageItem.subMessage = data.message;
    } else if (data.code === ItemNotFound) {
      messageItem.message = 'EmeraldItemNotFound';
      messageItem.subMessage = data.message;
    } else {
      messageItem = {
        type: EmeraldDialogTypes.Error,
        messageOverride: data.code,
        message: data.message,
      };
    }
    XLRLogger.error({
      message: `Get emerald error: ${data.code}`,
      source: 'popup-message.ts',
    });
  }

  // popup artificial message
  else if (data && (data.message || data.subMessage || data.type)) {
    messageItem = data;
    messageItem.subMessage = data.subMessage || '';
  }
  // log all other errors
  else {
    XLRLogger.error({
      message: `Get unknown error: ${data.message}`,
      source: 'popup-message.ts',
    });
  }
  if (resolve) {
    addDefaultAction(messageItem, resolve);
  }
  addDefaultButtons(messageItem, popEmeraldModal);
  showEmeraldDialog(messageItem);
};

export const popupAsyncMessage = async (messageItem: any): Promise<void> => {
  if (messageItem instanceof AbortedError) {
    return;
  }
  return new Promise(resolve => {
    popupMessage(messageItem, resolve);
  });
};

export const addDefaultAction = (messageItem: IMessageModal, action: () => void): void => {
  const { onAccept, onCancel } = messageItem;
  messageItem.onAccept = onAccept
    ? () => {
        action();
        onAccept();
      }
    : action;
  messageItem.onCancel = onCancel
    ? () => {
        action();
        onCancel();
      }
    : undefined;
  messageItem.hideCancelButton = !messageItem.onCancel;
};
